import { render, staticRenderFns } from "./previewExam.vue?vue&type=template&id=4c29ad62&scoped=true&"
import script from "./previewExam.vue?vue&type=script&lang=js&"
export * from "./previewExam.vue?vue&type=script&lang=js&"
import style0 from "./previewExam.vue?vue&type=style&index=0&id=4c29ad62&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c29ad62",
  null
  
)

export default component.exports